import { render, staticRenderFns } from "./CSVIcon.vue?vue&type=template&id=2db7cf57&scoped=true"
import script from "./CSVIcon.vue?vue&type=script&lang=js"
export * from "./CSVIcon.vue?vue&type=script&lang=js"
import style0 from "./CSVIcon.vue?vue&type=style&index=0&id=2db7cf57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7cf57",
  null
  
)

export default component.exports